// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb-container":"breadcrumb-component_breadcrumb-container__1UJrO"};